import React from 'react';
import "./auth.css";
import { Btn, FormInput } from '../../utils/utils';
import { Link } from 'react-router-dom';

const SignupComp = ({text, img}) => {
  return (
    <div className='sign-cont'>
        <div className="sign-left">
            <h2>Register with PrimeProperty as a <span>{text}</span></h2>
            <h3>Provide your details to create an account with us</h3>
            <div className="sign-form">
                <FormInput type="text" label={"Name"} placeholder="Samuel Eze" />
                <FormInput type="email" label={"Email"} placeholder="smauel@email.com" />
                <FormInput label={"Password"} placeholder="******" isPassword />
                <FormInput label={"Confirm Password"} placeholder="******" isPassword />
                <div className="sign-btn_cont">
                    <Btn btnClass={"home-btn sign-btn"} btnText={"Sign up"} btnLink={"/auth/tenant-signup"} />
                </div>
            </div>
            <p>Already have an account? <Link to={"/auth/signin"} style={{textDecoration: "none"}}><span>Login</span></Link></p>
        </div>
        <div className="sign-right">
            <img src={img} alt="tenant" />
        </div>
    </div>
  )
}

export default SignupComp